function SwipersInit() {
	const swipers = document.querySelectorAll('.swiper');

	swipers.forEach((swiperEl) => {
		if (swiperEl.classList.contains('swiper-our-team')) {
			const swiper = new Swiper(swiperEl, {
				slidesPerView: 1,
				spaceBetween: 16,
				grabCursor: true,
				scrollbar: {
					el: '.swiper-scrollbar',
					draggable: true,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
						spaceBetween: 16,
					},
					1024: {
						slidesPerView: 4,
						spaceBetween: 16,
					},
				},
			});
		} else if (swiperEl.classList.contains('swiper-news')) {
			const swiper = new Swiper(swiperEl, {
				speed: 500,
				effect: 'fade',
				fadeEffect: {
					crossFade: true,
				},
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					clickable: true,
				},
				autoHeight: true,
			});
		} else if (swiperEl.classList.contains('swiper-community-news')) {
			const swiper = new Swiper(swiperEl, {
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				spaceBetween: 20,
				speed: 500,
				autoHeight: true,
				breakpoints: {
					768: {
						slidesPerView: 2,
					},
				},
			});
		} else if (swiperEl.classList.contains('swiper-hero-text')) {
			const text_swiper = new Swiper(swiperEl, {
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				speed: 500,
				effect: 'fade',
				fadeEffect: {
					crossFade: true,
				},
			});

			const media_swiperEL = document.querySelector('.swiper-hero-media');

			const media_swiper = new Swiper(media_swiperEL, { loop: true });

			text_swiper.controller.control = [media_swiper];
		} else if (swiperEl.classList.contains('swiper-news-selection')) {
			const swiper = new Swiper(swiperEl, {
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				slidesPerView: 1,
				spaceBetween: 16,
				breakpoints: {
					768: {
						slidesPerView: 2,
						spaceBetween: -16,
					},
				},
			});
			const image = swiperEl.querySelector('img');
			const wrapper = swiperEl.closest('.community-news-section__wrapper');
			wrapper.style.setProperty('--cns-ratio', image.clientHeight + 'px');
		} else if (swiperEl.classList.contains('swiper-project-gallery')) {

			const image_slides = document.querySelectorAll('.swiper-slide-pg-image');
			const image_captions = document.querySelectorAll('.swiper-slide-pg-image-caption');

			const video_slides = document.querySelectorAll('.swiper-slide-pg-video');
			const video_captions = document.querySelectorAll('.swiper-slide-pg-video-caption');

			const btns = document.querySelectorAll('.project-gallery-section__btn');

			const textEl = document.querySelector('.project-gallery-section__text');
			const initialText = textEl.innerHTML;

			let swiper = null;

			let current = 'image';

			btns.forEach((btn) => {
				btn.addEventListener('click', buttonClick);
			})

			function buttonClick(event){

				btns.forEach((btn) => {
					btn.classList.add('btn-outline-primary');
					btn.classList.remove('btn-primary')
				});

				event.target.classList.remove('btn-outline-primary');
				event.target.classList.add('btn-primary')

				swiper.removeAllSlides();
				if(event.target.name === 'image'){
					swiper.appendSlide(image_slides);
					current = 'image';
					changeCaption(0)
				} else {
					swiper.appendSlide(video_slides);
					current = 'video';
					changeCaption(0)
				}
			}
		
			function changeCaption(index) {
				if(current === 'image' && image_captions[index]?.children.length > 0){
					textEl.innerHTML = image_captions[index].innerHTML;
				} else if(current === 'video' && video_captions[index]?.children.length > 0){ 
					textEl.innerHTML = video_captions[index].innerHTML;
				} else {
					textEl.innerHTML = initialText;
				}
			}

				
			swiper = new Swiper(swiperEl, {
				slidesPerView: 1,
				spaceBetween: 16,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				on: {
					init: function (e) {
						changeCaption(e.activeIndex);
					},
					slideChange: function (e) {
						changeCaption(e.activeIndex);
					},
				},
			});

			swiper.removeAllSlides();
			// swiper.udpate();
			if(image_slides.length > 0){
				swiper.appendSlide(image_slides);
				current = 'image';
				changeCaption(0)
			} else {
				swiper.appendSlide(video_slides);
				current = 'video';
				changeCaption(0)
			}

		} else if (swiperEl.classList.contains('swiper-featured-projects')) {
			const swiper = new Swiper(swiperEl, {
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				spaceBetween: 20,
				speed: 500,
				autoHeight: true,
				breakpoints: {
					768: {
						slidesPerView: 2,
					},
				},
			});
		}
	});
}

